import { render, staticRenderFns } from "./bindingAdapter.vue?vue&type=template&id=50bb1756"
import script from "./bindingAdapter.vue?vue&type=script&lang=js"
export * from "./bindingAdapter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports